module.exports = __webpack_public_path__ + "staticcomp/img/top.1176100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/top.jpg
// module id = SDAJ
// module chunks = 39